<template>
  <div class="Section" ref="root">
    <div class="Section-Content" :class="class_root">
      <a @click="() => toggle()" class="Section-Click">
        <div class="Section-Click-Background">
          <img class="UserGroup" src="/img/global/userGroup.svg" alt="User Group"/>
          <span class="Section-Title">{{ title }}</span>
          <img class="Polygone" src="/img/global/polygone.svg" alt="Polygone"/>
        </div>
      </a>
      <ul>
        <li v-for="(data, index) in content" :key="index">
          <img src="/img/global/check.svg" alt="Check Icon"/>
          <span v-html="data"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Section",
  props: {
    title: {
      type: String,
      default: () => ''
    },
    content: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      displayed: false
    }
  },
  computed: {
    class_root() {
      const classes = []
      if (!this.displayed) classes.push('hide')
      return classes
    }
  },
  methods: {
    toggle() {
      this.displayed = !this.displayed
    }
  }
}
</script>

<style scoped>
/* 
* Global
*/
.Section {
  margin: 25px auto;
  width: 80%;
}

/* 
* Bandeau
*/
.Section-Click {
  border-left: solid 2px #00AEB0;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  border-radius: 0px 5px 5px 0px;
  background: rgba(0, 0, 0, 0.03);
}

.Section-Click-Background {
  position: relative;
  padding: 11px 50px 11px 20px;
  width: calc(100% - 3px);
  margin-left: 3px;
  border-radius: 0px 5px 5px 0px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  align-content: center;
}

.Section-Title {
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  text-transform: uppercase;
  font-weight: bolder;
}


/* 
* Icon
*/
.UserGroup {
  width: 30px;
  margin-right: 20px;
}

.Polygone {
  width: 15px;
  position: absolute;
  right: 40px;
  transition: all 500ms;
}

.hide .Polygone {
  transform: rotate(90deg);
}

/* 
* List
*/
ul {
  list-style: none;
  padding: 0;
  margin-left: 80px;
  max-height: 350px;
  overflow: hidden;
  transition: all 500ms;
}

.hide ul {
  height: auto;
  max-height: 0px;
}

li {
  border-left: 1px solid #00919B;
  height: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
}

li img {
  width: 25px;
}

li span {
  font-size: 14px;
  color: #00919B;
  margin-left: 15px;
}

/* 
* Responsive
*/
@media (max-width: 925px) {
  /*
  * Bandeau
  */
  .Section-Click-Background {
    padding: 11px 15px 11px 15px;
  }

  .Section-Title {
    width: 75%;
  }

  /*
  * Icon
  */
  .UserGroup {
    margin-right: 25px;
  }

  .Polygone {
    right: 15px;
  }

  /*
  * List
  */
  ul {
    margin-left: 35px;
  }
}

@media (max-width: 925px) {
  .Section-Title {
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  /*
  * Icon
  */
  .UserGroup {
    margin-right: 10px;
  }
}
</style>